// src/utils/supabase-storage.js — purga del estado de auth de Supabase en
// localStorage.
//
// PWA y browser comparten localStorage. Un logout a medias (o un access token
// roto con refresh token vivo) deja claves `sb-<ref>-auth-token` en estado
// inconsistente; el próximo initAuth las relee e intenta refrescar un token
// muerto → se cuelga / pierde minutos → loop de boot corrompido. Esta purga
// rompe ese loop: borra TODA clave de Supabase y arranca limpio (sin sesión).

export const purgeSupabaseAuthStorage = () => {
  if (typeof localStorage === 'undefined') return 0
  let removed = 0
  try {
    // 1) Juntar las claves primero (no borrar mientras se itera por índice).
    const aBorrar = []
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (k && (k.startsWith('sb-') || k === 'supabase.auth.token')) aBorrar.push(k)
    }
    for (const k of aBorrar) {
      try { localStorage.removeItem(k); removed++ } catch (_) { /* clave trabada, seguir */ }
    }
  } catch (_) { /* localStorage inaccesible (incógnito estricto): nada que purgar */ }
  return removed
}
